let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5odbj"), load("P2OWY"), load("7A5zJ"), load("lPQcc"), load("6lM2n")]).then(() => parcelRequire('cPug3'));